import { ParsedItem } from 'store/declaration-form-errors/ParsedForm';
import { ItemErrorCounts } from './getRejectedItemErrorCounts';

/**
 * The ids of the items with errors - from the customs rejection or the form validation. They are
 * known by id, so they are right even when not every item is listed.
 *
 * A validation item without an id can only be placed by its row, which a filter cannot use, so it
 * is left out.
 */
const getItemIdsWithErrors = (
    validationItems: ParsedItem[],
    rejectedErrorCountByItemId: ItemErrorCounts
): Set<string> => {
    const customsItemIds = Object.keys(rejectedErrorCountByItemId);
    const validationItemIds = validationItems.flatMap(({ id }) => (id ? [id] : []));

    return new Set([...customsItemIds, ...validationItemIds]);
};

export default getItemIdsWithErrors;
